import { SurveyQuestionResponse } from "@yardzen/api-dtos";
import { UseFormRegister } from "react-hook-form";
import { MultipleTextFieldsResponsesType } from "../QuizQuestionHandler";
import { Input } from "@yardzen/ui/components/input";

export default function MultipleTextFieldsResponse({
  fields,
  surveyQuestionResponse,
  register,
}: {
  fields: {
    key: string;
    label: string;
  }[];
  surveyQuestionResponse?: SurveyQuestionResponse;
  register: UseFormRegister<any>;
}) {
  const responses: MultipleTextFieldsResponsesType =
    surveyQuestionResponse?.response
      ? JSON.parse(surveyQuestionResponse.response)
      : [];

  return (
    <div className="flex w-full flex-col flex-nowrap justify-center gap-4 px-4 sm:w-3/5 sm:px-0">
      {fields.map((field, index) => (
        <div key={index}>
          <Input
            maxLength={150}
            placeholder={field.label}
            className="bg-brand-secondary-lighter w-full rounded-md p-4"
            defaultValue={
              responses.find((res) => res.key === field.key)?.value || ""
            }
            {...register(field.key)}
          />
        </div>
      ))}
    </div>
  );
}
